// extracted by mini-css-extract-plugin
module.exports = {"columns":"SearchResults_columns__eh_hE","imgContainer":"SearchResults_imgContainer__Vo7N5","img":"SearchResults_img__i0eps"};